var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "f0fc6b4552440f2c4252627f4cd2194765e31603"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["launchpad@printdeal"] = {
  id: "f0fc6b4552440f2c4252627f4cd2194765e31603"
};